// extracted by mini-css-extract-plugin
export default {"fields":"DYacCP","time":"ozrRKw","mobile":"ClcIU8"};